import { Directive, HostListener, ElementRef } from '@angular/core';
import { ExternalLinkService } from '../services/external-link.service';
import { AppComponent } from '../app.component';

@Directive({
  selector: '[appExternalLink]'
})
export class ExternalLinkDirective {
  constructor(
    private externalLinkService: ExternalLinkService,
    private appComponent: AppComponent,
    private el: ElementRef
  ) {
    //console.log('appExternalLink attribute applied to:', this.el.nativeElement);
  }

  readonly homeUrl: string = '#/home#';  // Main landing page for application

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (event.button === 0) { // Only allow left-click
      this.handleLinkClick(event);
    } else {
      event.preventDefault();
    }
  }

  @HostListener('contextmenu', ['$event'])
  onContextMenu(event: MouseEvent) {
    event.preventDefault(); // Prevent the context menu from appearing
  }

  @HostListener('auxclick', ['$event'])
  onAuxClick(event: MouseEvent) {
    event.preventDefault();
  }

  private handleLinkClick(event: MouseEvent) {
    event.preventDefault(); // Prevent default behavior

    let url: string | null = null;
    let target: string | null = null;

    console.log('External link clicked:', url);

    // If directive is on <a>, use its href attribute
    if (this.el.nativeElement.tagName === 'A') {
      url = this.el.nativeElement.getAttribute('href');
      target = this.el.nativeElement.getAttribute('target');
    }

    // If directive is on <img>, find the nearest <a> tag
    else if (this.el.nativeElement.tagName === 'IMG') {
      const parentAnchor = this.el.nativeElement.closest('a');
      if (parentAnchor) {
        url = parentAnchor.getAttribute('href');
        target = parentAnchor.getAttribute('target');
      }
    }

    if (!url) {
      console.warn('appExternalLink: No valid URL found.');
      return;
    }

    if (this.externalLinkService.isExternalLink(url)) {
      console.log('External link detected!');
      this.appComponent.showExternalLinkModalPopup(event, url, target ?? '_blank');
    } else {
      console.log('Internal link, navigating!', url);
      if (url.endsWith(this.homeUrl))  // Always open home URL in same tab
        target = '_self';
      window.open(url, target ?? '_blank');
    }
  }
}
